import type { IconNode } from '../types';

/**
 * @name tire
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjYiIC8+CiAgPHBhdGggZD0iTTEyIDE0djQiIC8+CiAgPHBhdGggZD0ibTEwLjEgMTIuNjItMy44IDEuMjMiIC8+CiAgPHBhdGggZD0iTTEwLjgyIDEwLjM4IDguNDcgNy4xNSIgLz4KICA8cGF0aCBkPSJtMTMuOSAxMi42MiAzLjggMS4yMyIgLz4KICA8cGF0aCBkPSJtMTMuMTggMTAuMzggMi4zNS0zLjIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/tire
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const tire: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
  ['circle', { cx: '12', cy: '12', r: '6', key: '1vlfrh' }],
  ['path', { d: 'M12 14v4', key: '1thi36' }],
  ['path', { d: 'm10.1 12.62-3.8 1.23', key: '65fvw6' }],
  ['path', { d: 'M10.82 10.38 8.47 7.15', key: '1o4mzi' }],
  ['path', { d: 'm13.9 12.62 3.8 1.23', key: 'm4ix74' }],
  ['path', { d: 'm13.18 10.38 2.35-3.23', key: '18e8u9' }],
];

export default tire;
